/**
 * API Wrapper for communication with PHP Backend
 */

export const login = async (password) => {
  const response = await fetch('/api/auth.php?action=login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password })
  });
  if (!response.ok) throw new Error('Login fehlgeschlagen');
  return response.json();
};

export const checkAuth = async () => {
  const response = await fetch('/api/auth.php?action=check');
  return response.json();
};

export const logout = async () => {
  await fetch('/api/auth.php?action=logout');
};

export const getFiles = async () => {
  const response = await fetch('/api/files.php');
  if (!response.ok) throw new Error('Fehler beim Laden der Dateien');
  return response.json();
};

export const uploadFile = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);

  // In a real environment, we'd use XMLHttpRequest for progress tracking
  // but for simplicity with fetch:
  const response = await fetch('/api/upload.php', {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || 'Upload fehlgeschlagen');
  }

  return response.json();
};

export const deleteFile = async (id) => {
  const response = await fetch('/api/delete.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id })
  });
  if (!response.ok) throw new Error('Fehler beim Löschen');
  return response.json();
};